module.exports = __webpack_public_path__ + "static/media/empa-logo.ab4e28f9.png";